import { Dialog } from '@mui/material';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { isDesktop } from 'react-device-detect';

import { useDeviceService } from '../../hooks';
import { DEVICE_TYPE } from '../../types/deviceType';

import imgiOS from '../../assets/obBoardingiOS.png';
import imgAndroid from '../../assets/obBoardingAndroid.png';

const OnBoarding = ({ trigger }) => {
	const { getDeviceType } = useDeviceService();

	const [isOpen, setOpen] = useState(false);

	const getImageByDevice = () =>
		DEVICE_TYPE.IOS === getDeviceType() ? imgiOS : imgAndroid;

	const adjustImageToScreenDevice = () => {
		return isDesktop ? window.innerWidth : window.innerWidth * 3;
	};

	useEffect(() => {
		if (trigger) {
			setOpen(true);
		}
	}, [trigger]);

	return (
		<Dialog
			fullWidth={true}
			maxWidth={'xl'}
			open={isOpen}
			style={{
				maxWidth: '100%',
				maxHeight: '100%',
				width: '100vw',
				height: '100vh',
				overflow: 'hidden',
			}}
		>
			<StyledButtonClose
				onClick={() => {
					setOpen(false);
				}}
			>
				X
			</StyledButtonClose>
			<img
				style={{
					display: 'block',
					width: adjustImageToScreenDevice(),
					height: '80vh',
					objectFit: 'fill',
				}}
				src={getImageByDevice()}
				alt=""
			/>
		</Dialog>
	);
};
const StyledButtonClose = styled.button`
	display: flex;
	height: 10px;
	width: 10px;
	padding: 1.5rem;
	font-size: 16px;
	alignself: flex-start;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	background: transparent;
	border: 0;
`;

export default OnBoarding;
